import { lazy, Suspense } from "react";
import Layout from "./Layout";
import Home from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../styles/App.css";
import "../styles/MobileResponsive.css";
import "./Script";
import ScrollToTop from "./ScrollToTop";
import AnnouncementBar from "./AnnouncementBar";

// Lazy load all pages for code splitting
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));
const BlogSystem = lazy(() => import("./pages/BlogSystem"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));
const BlogOne = lazy(() => import("./blogs/Blog01"));
const BlogTwo = lazy(() => import("./blogs/Blog02"));
const CaseStory = lazy(() => import("./pages/CaseStory"));
const FirstCaseStory = lazy(() => import("./case-stories/FirstCaseStory"));
const SecondCaseStory = lazy(() => import("./case-stories/SecondCaseStory"));
const ThirdCaseStory = lazy(() => import("./case-stories/ThirdCaseStory"));
const FourthCaseStory = lazy(() => import("./case-stories/FourthCaseStory"));
const FifthCaseStory = lazy(() => import("./case-stories/FifthCaseStory"));
const SixthCaseStory = lazy(() => import("./case-stories/SixthCaseStory"));
const SeventhCaseStory = lazy(() => import("./case-stories/SeventhCaseStory"));
const CaseStoryOne = lazy(() => import("./case-stories/CaseStoryOne"));
const CaseStoryTwo = lazy(() => import("./case-stories/CaseStoryTwo"));
const Service1 = lazy(() => import("./landing_page/Service1"));
const Service2 = lazy(() => import("./landing_page/Service2"));
const Service3 = lazy(() => import("./landing_page/Service3"));
const Service4 = lazy(() => import("./landing_page/Service4"));
const Service5 = lazy(() => import("./landing_page/Service5"));
const Service6 = lazy(() => import("./landing_page/Service6"));
const Service7 = lazy(() => import("./landing_page/Service7"));
const Service8 = lazy(() => import("./landing_page/Service8"));
const Service9 = lazy(() => import("./landing_page/Service9"));
const Service10 = lazy(() => import("./landing_page/Service10"));
const Service11 = lazy(() => import("./landing_page/Service11"));
const Service12 = lazy(() => import("./landing_page/Service12"));
const ShopifyPortfolio = lazy(() => import("./pages/ShopifyPortfolio"));
const WordPressPortfolio = lazy(() => import("./pages/WordPressPortfolio"));
const MobileAppPortfolio = lazy(() => import("./pages/MobileAppPortfolio"));
const CustomSoftwarePortfolio = lazy(() => import("./pages/CustomSoftwarePortfolio"));
const DataAnalyticsPortfolio = lazy(() => import("./pages/DataAnalyticsPortfolio"));
const UIUXPortfolio = lazy(() => import("./pages/UIUXPortfolio"));
const ShopifyForBeauty = lazy(() => import("./pages/ShopifyForBeauty"));
const ShopifyForFashion = lazy(() => import("./pages/ShopifyForFashion"));
const ShopifyForPet = lazy(() => import("./pages/ShopifyForPet"));
const ShopifyForHealth = lazy(() => import("./pages/ShopifyForHealth"));
const ComparisonPage = lazy(() => import("./pages/ComparisonPage"));
const ROICalculator = lazy(() => import("./pages/ROICalculator"));
const ClientOnboarding = lazy(() => import("./pages/ClientOnboarding"));
const SpeedTestTool = lazy(() => import("./pages/SpeedTestTool"));
const NotFound = lazy(() => import("./pages/NotFound"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsConditions = lazy(() => import("./pages/TermsConditions"));
const Careers = lazy(() => import("./pages/careers"));
const HowWeWork = lazy(() => import("./pages/HowWeWork"));
const ShopifyServiceLanding = lazy(() => import("./landing_page/LandingPage1"));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AnnouncementBar />
      <Layout>
        <Suspense fallback={<div style={{minHeight:"60vh",display:"flex",alignItems:"center",justifyContent:"center"}}><div style={{width:36,height:36,border:"3px solid #e5e7eb",borderTop:"3px solid #2563eb",borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div>}>
          <Routes>
            <Route exact path="/" Component={Home} />
            <Route exact path="/about" Component={About} />
            <Route exact path="/blogs" Component={BlogSystem} />
            <Route exact path="/blog/:slug" Component={BlogPostPage} />
            <Route exact path="/blogs/:name" Component={BlogOne} />
            <Route exact path="/blogs/:name" Component={BlogTwo} />
            <Route exact path="/services" Component={Services} />
            <Route exact path="/case-story" Component={CaseStory} />
            <Route exact path="/shopify-conversion-rate-optimization-how-we-increased-sales-without-more-ads" Component={FirstCaseStory} />
            <Route exact path="/how-a-sales-funnel-tripled-our-clients-revenue" Component={FourthCaseStory} />
            <Route exact path="/shopify-store-redesign-case-study-2-to-4-percent-conversion-rate" Component={ThirdCaseStory} />
            <Route exact path="/15-days-11k-revenue-and-zero-inventory" Component={FifthCaseStory} />
            <Route exact path="/from-2-failed-builds-to-pixel-perfect-in-10-days" Component={SixthCaseStory} />
            <Route exact path="/how-a-7-figure-brand-added-620k-in-revenue" Component={SeventhCaseStory} />
            <Route exact path="/shopify-speed-optimization-guide-for-higher-revenue" Component={SecondCaseStory} />
            <Route exact path="/eleven-days-changed-everything" Component={CaseStoryOne} />
            <Route exact path="/tripe-sales-through-migration" Component={CaseStoryTwo} />
            <Route exact path="/contact" Component={Contact} />
            <Route exact path="/services/complete-shopify-store-setup" Component={Service1} />
            <Route exact path="/services/professional-dropshipping-website" Component={Service2} />
            <Route exact path="/services/seamless-sales-funnel-integration" Component={Service3} />
            <Route exact path="/services/shopify-cro-speed-enhancement" Component={Service4} />
            <Route exact path="/services/pixel-perfect-figma-to-shopify-conversion" Component={Service5} />
            <Route exact path="/services/shopify-brand-redesign-refresh" Component={Service6} />
            <Route exact path="/services/effortless-website-migration" Component={Service7} />
            <Route exact path="/services/custom-website-development" Component={Service8} />
            <Route exact path="/services/e-commerce-data-management" Component={Service9} />
            <Route exact path="/services/e-commerce-data-visualization" Component={Service10} />
            <Route exact path="/services/advanced-data-analytics" Component={Service11} />
            <Route exact path="/services/shopify-app-development" Component={Service12} />
            <Route exact path="/services/shopify-development" Component={ShopifyPortfolio} />
            <Route exact path="/services/wordpress-development" Component={WordPressPortfolio} />
            <Route exact path="/services/mobile-app-development" Component={MobileAppPortfolio} />
            <Route exact path="/services/custom-software" Component={CustomSoftwarePortfolio} />
            <Route exact path="/services/data-analytics" Component={DataAnalyticsPortfolio} />
            <Route exact path="/services/uiux-design" Component={UIUXPortfolio} />
            <Route exact path="/shopify-for-beauty-brands" Component={ShopifyForBeauty} />
            <Route exact path="/shopify-for-fashion-brands" Component={ShopifyForFashion} />
            <Route exact path="/shopify-for-pet-supplements" Component={ShopifyForPet} />
            <Route exact path="/shopify-for-health-wellness" Component={ShopifyForHealth} />
            <Route exact path="/compare" Component={ComparisonPage} />
            <Route exact path="/roi-calculator" Component={ROICalculator} />
            <Route exact path="/our-process" Component={ClientOnboarding} />
            <Route exact path="/speed-test" Component={SpeedTestTool} />
            <Route path="*" Component={NotFound} />
            <Route exact path="/privacy-policy" Component={PrivacyPolicy} />
            <Route exact path="/terms-conditions" Component={TermsConditions} />
            <Route exact path="/careers" Component={Careers} />
            <Route exact path="/how-we-work" Component={HowWeWork} />
            <Route exact path="/lp1" Component={ShopifyServiceLanding} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
